import { getRouteApi, useNavigate } from '@tanstack/react-router';

import { FormattedMessage, useIntl } from 'react-intl';

import Spacings from '~/modules/ui-kit/spacings';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import BackIcon from '@mui/icons-material/ArrowBack';

import ContentView from '~/components/ContentView';
import CongregationForm from '~/components/CongregationForm';

import { useCreateCongregation } from '~/hooks/api/useCreateCongregation';
import { CreateCongregation } from '~/generated';
import { useCircuits } from '~/hooks/api/useCircuits';
import messages from './messages';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

const route = getRouteApi('/congregations/new');

export const CongregationCreate = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const search = route.useSearch();
  const handleBackButton = () => {
    navigate({ to: search.from || '/congregations' });
  };
  const { data: circuits, isLoading: isLoadingCircuits } = useCircuits();
  const createCongregationMutation = useCreateCongregation({
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      // we redirect the user back to the circuit list page
      handleBackButton();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });
  const isLoading = createCongregationMutation.isPending || isLoadingCircuits;
  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Spacings.Inline alignItems="center">
              <IconButton
                color="inherit"
                onClick={handleBackButton}
                size="large"
              >
                <BackIcon data-testid="back" />
              </IconButton>
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </div>
            </Spacings.Inline>
          </Toolbar>
        </AppBar>
      }
      isLoading={isLoading}
    >
      {!isLoadingCircuits && circuits && (
        <CongregationForm
          onSubmit={(values) =>
            createCongregationMutation.mutate({
              name: values.name,
              circuitId: values.circuit,
              number: values.watchtowerId || null,
            } as CreateCongregation)
          }
          circuits={circuits}
        />
      )}
    </ContentView>
  );
};

export default CongregationCreate;
